export const Image = 0;
export const Tuile = 1;
export const GeoJSON = 2;
export const QgisWms = 3;
